export default __webpack_public_path__ + "static/media/template_category_cover.6d0f3c8a.jpg";